<template>
  <div class="row upload-area mx-3 my-2" @dragleave.prevent @dragover.prevent @drop.prevent="onDrop">
    <div class="col">
      <img src="@/assets/images/cloud_up.png"/>
      <p v-html="textHtml" style="font-size:14px;"/>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import * as Common from "../commons/common"

export default Vue.extend({
  props:["textHtml", "extensions", "isMultiple"],
  methods: {
    onDrop(event){

      var extensionTemp = null;

      for(const file of event.dataTransfer.files){
        var extension = Common.getFileExtension(file.name);
        if(!this.extensions.includes(extension)) {
          this.$emit('drop-error', `ファイル拡張子が異なるファイルが含まれています。ドラッグ可能な拡張子は${this.extensions.toString()}です。`);
          return;
        }

        if(extensionTemp && extension != extensionTemp){
          this.$emit('drop-error', `複数のファイル拡張子が混在しています。アップロードできる拡張子は1種類です。`);
          return;
        }

        extensionTemp = extension;
      }

      if(extensionTemp == "xlsx"){
        this.$emit('drop-success', event.dataTransfer.files[0]);
      }else if(extensionTemp != "jpg"){
        if(event.dataTransfer.files.length > 1){
          this.$emit('drop-error', `${extensionTemp}の複数ファイルはアップロードできません。1ファイルでアップロードしてください。`);
          return;
        }

        this.$emit('drop-success', event.dataTransfer.files);
      }else{
        this.$emit('drop-success', event.dataTransfer.files);
      }
    }
  }
})
</script>
